import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'

import contentImageUrl from '../static/img/content-planning.jpg'

class Planning extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div id="scroll-target" className="container">
          <SectionTitle
            intro
            icon="icon-planning.svg"
            title="Planning"
          />

          <div className="layout layout--content layout--pb-lg">
            <div className="layout__item layout__item--half">
              <p>GDL specialise in bringing forward strategic employment sites, structuring the delivery of infrastructure to suit the requirements of corporate occupiers and thereafter build out to hold or sell into the marketplace.</p>
              <p>The UK’s planning policy framework is constantly in a state of transition, making early and detailed discussions with both the local authority and local stakeholders ever more important.</p>
              <p><img src={contentImageUrl} alt="" /></p>
            </div>
            <div className="layout__item layout__item--half">
              <p><span className="copy--bold-x copy--purple">Our expertise includes:</span></p>
              <ul>
                <li>recognising the need and desire to deliver an environmentally acceptable product</li>
                <li>negotiation of financial contributions </li>
                <li>building design and highway solution negotiations</li>
                <li>provision of social housing contributions </li>
                <li>development within sensitive flood areas</li>
                <li>master planning briefs</li>
                <li>mixed use schemes</li>
                <li>contaminated land</li>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Planning;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Planning.js